<template>
  <div class="apply">
    <el-card class="card">
      <h2>渠道入驻申请</h2>
      <el-form v-if="!done" label-width="100px" size="small">
        <el-form-item label="级别">
          <el-select v-model="form.levelCode">
            <el-option v-for="(name, code) in levels" :key="code" :label="name" :value="code" />
          </el-select>
        </el-form-item>
        <el-form-item label="主体名称" required><el-input v-model="form.name" placeholder="必填" /></el-form-item>
        <el-form-item label="执照号" required><el-input v-model="form.licenseNo" placeholder="必填" /></el-form-item>
        <el-form-item label="法人姓名" required><el-input v-model="form.legalName" placeholder="必填" /></el-form-item>
        <el-form-item label="身份证号" required><el-input v-model="form.idCardNo" maxlength="18" placeholder="18位，末位可为 X" /></el-form-item>
        <el-form-item label="手机号" required><el-input v-model="form.phone" maxlength="11" placeholder="11位手机号" /></el-form-item>
        <el-form-item label="区划代码" required><el-input v-model="form.regionCode" placeholder="省市区必填" /></el-form-item>
        <el-form-item label="地区名称"><el-input v-model="form.regionName" /></el-form-item>
        <el-form-item label="行业代码"><el-input v-model="form.industryCode" placeholder="行业代理必填" /></el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="submit">提交申请</el-button>
          <el-button @click="$router.push('/admin/login')">返回登录</el-button>
        </el-form-item>
      </el-form>
      <div v-else>
        <p>申请已提交。通过前没有邀请码。可以用手机号查询进度。</p>
        <el-button type="primary" @click="done = false">继续</el-button>
      </div>
      <div class="progress">
        <h3>用手机号查进度</h3>
        <el-input v-model="phone" placeholder="申请时填写的手机号" size="small" />
        <el-button size="small" :loading="querying" @click="lookup">查询</el-button>
        <p v-for="row in progress" :key="row.createdAt + row.name">
          {{ row.name }} · {{ levels[row.levelCode] || row.levelCode }} · {{ statusText(row.status) }}
          <span v-if="row.rejectReason">，{{ row.rejectReason }}</span>
        </p>
        <p v-if="queried && !progress.length">没有找到这个手机号的申请。</p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { registerChannel, channelProgress } from '@/api/admin'
import { LEVELS } from '../partner/labels'

export default {
  name: 'ChannelApply',
  data() {
    return {
      levels: LEVELS,
      loading: false,
      querying: false,
      queried: false,
      done: false,
      id: '',
      phone: '',
      progress: [],
      form: {
        levelCode: 'DISTRICT', name: '', licenseNo: '', legalName: '', idCardNo: '',
        phone: '', regionCode: '', regionName: '', industryCode: ''
      }
    }
  },
  methods: {
    async submit() {
      const form = this.form
      const idCard = String(form.idCardNo || '').trim().toUpperCase()
      const phone = String(form.phone || '').trim()
      if (!form.name || !form.licenseNo || !form.legalName || !idCard || !phone || !form.regionCode) {
        this.$message.warning('主体、执照、法人、身份证、手机和区划代码都要填')
        return
      }
      if (!/^\d{17}[\dX]$/.test(idCard)) {
        this.$message.warning('身份证号须为 18 位，前 17 位数字，末位可为数字或 X')
        return
      }
      if (!/^1\d{10}$/.test(phone)) {
        this.$message.warning('手机号须为 11 位纯数字')
        return
      }
      this.loading = true
      try {
        const result = await registerChannel({
          ...form,
          idCardNo: idCard,
          phone
        })
        this.id = result.id
        this.done = true
        this.phone = phone
      } catch (error) {
        this.$message.error((error && error.message) || '提交失败')
      } finally {
        this.loading = false
      }
    },
    statusText(status) {
      if (status === 'APPROVED') return '已通过，请用开通的账号登录'
      if (status === 'REJECTED') return '已驳回，可以修改后重新提交'
      return '待审核，通过前没有邀请码'
    },
    async lookup() {
      if (!this.phone) return
      this.querying = true
      try {
        const result = await channelProgress(this.phone.trim())
        this.progress = result.list || []
        this.queried = true
      } catch (error) {
        this.$message.error((error && error.message) || '查询失败')
      } finally {
        this.querying = false
      }
    }
  }
}
</script>

<style scoped>
.apply { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f3f5fb; }
.card { width: 560px; }
h2 { margin: 0 0 8px; }
h3 { margin: 16px 0 8px; font-size: 14px; }
p { color: #667; margin-bottom: 16px; }
.progress { margin-top: 8px; padding-top: 8px; border-top: 1px solid #e7ebf3; }
.progress .el-input { width: 240px; margin-right: 8px; }
</style>
